namespace $ {

	export interface $mol_buffer {
		mix( mixin: Uint8Array< ArrayBuffer > ): this
	}

	export function $shm_compat_buffer_mix_install() {
		const proto = $mol_buffer.prototype
		if( ( proto as unknown as { mix?: unknown } ).mix ) return

		Object.defineProperty( proto, 'mix', {
			configurable: true,
			value( this: $mol_buffer, mixin: Uint8Array< ArrayBuffer > ) {
				const target = this.asArray()
				for( let index = 0; index < mixin.length; ++ index ) {
					target[ index % target.byteLength ] ^= mixin[ index ]
				}
				return this
			},
		} )
	}

}
